import React from 'react';
import NotInformation from '../NotInformation';
import {useTranslation} from 'react-i18next';
import CenterPhotoPicker from './SubComponent/CenterPhotoPicker';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Viewer component for the selected photo or image
 * @param model: photoPicker: Photo/image component model
 * @param string classWith: for container size, used when centering the component (w-100, w-400px, other ), but it will always be centered
 * @param boolean noInformation: if preview is required in card
 */
const PhotoPickerSummary = ({ photoPicker, classWith='w-100', noInformation=true}) => {

    const { t } = useTranslation();
    const preview= photoPicker?.selfieSrc || photoPicker?.srcSelected || photoPicker.previewImage;
    return (<>
        { (preview) ?
            <CenterPhotoPicker classWith={classWith}>
                <div className={`photo-picker-summary-prev d-flex justify-content-center align-items-center text-center prev-border-bottom h-276px photo-picker-bg-image`}>
                    <div className='photo-picker-image'>
                        <img className={'preview'} src={ preview }/>
                    </div>
                </div>
            </CenterPhotoPicker>
            :
            <>
                {
                    noInformation &&
                    <div className='col-12'>
                        <NotInformation text={t('no_information')} card={true} />
                    </div>
                }
            </>
        }
    </>);
}

export default PhotoPickerSummary;
